// LOCAL VARIABLES
import { COLUMNS } from '../../../../columns.js';

export const DELIVERED_TOTALS_COLUMNS = [
  [
    {
      value: 'Total',
      className: 'fw-bolder',
      width: 120
    },
    {
      ...COLUMNS.frontendGrossBP,
      key: 'frontend_gross_before_pack_total'
    },
    {
      ...COLUMNS.amGross,
      key: 'am_gross_total'
    },
    {
      ...COLUMNS.fiGross,
      key: 'fi_gross_total'
    },
    {
      ...COLUMNS.backendGrossBP,
      key: 'backend_gross_before_pack_total'
    },
    {
      ...COLUMNS.totalGrossBP,
      key: 'total_fe_be_gross_before_pack_total'
    },
    {
      ...COLUMNS.dealerPack,
      key: 'dealer_pack_total_total'
    },
    {
      ...COLUMNS.totalGrossAP,
      key: 'total_fe_be_gross_after_pack_total'
    }
  ]
];
